import { getViewerUrl } from "@Helpers";
import type { IssueItem } from "@ServerTypes/issues/issues.schema";

/**
 * An issue can be opened in the viewer only when it is associated with a file/model version.
 * Issues without a file version are "standalone" and have no viewer to open.
 * (Mirrors the `fileVersionId` gate on IssueDetails' "View in Viewer" button.)
 */
export const isIssueOpenableInViewer = (issue: IssueItem): boolean => Boolean(issue.fileVersionId);

/**
 * Builds the design-viewer URL for an issue — the same navigation used by
 * Issue Details → "View in Viewer" (`IssueDetails.handleOpenFileLink`).
 *
 * Returns `undefined` for standalone issues (no file version) or when the project id is missing
 * (`getViewerUrl` itself returns `undefined` without a `projectId`).
 */
export const getIssueViewerUrl = (issue: IssueItem): string | undefined =>
  getViewerUrl({
    fileVersionId: issue.fileVersionId,
    issueId: issue.id,
    spaceId: issue.spaceId,
    projectId: issue.projectUniqueId,
  });
